
export default {
  model: {
    prop: 'formData',
    event: 'formDataChange',
  },
  props: {
    formData: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
  },
  computed: {
    mutableFormData: {
      get() { return this.formData; },
      set(value) { this.$emit('formDataChange', value); },
    },
  },
};
